import React, { ReactElement } from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

import { ApiListInterface } from 'interfaces/api.interface';
import { NewsItemInterface } from 'interfaces/news-item.interface';
import NewsArticle from 'components/news/article/news-article';

const NewsListBase: React.FC = (): ReactElement => {
    const newsList = useSelector(
        (state: { newsList: ApiListInterface<NewsItemInterface>; }) => state.newsList
    );

    return (
        <div className="news-list">
            {
                newsList.items.map(item => (
                    <NewsArticle key={item.slug} newsItem={item} asListItem={true} />
                ))
            }
        </div>
    );
};

export default NewsListBase;
